import React, { FC, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import SearchCloudCircleIcon from "@assets/svg/search-cloud-circle.svg";
import { Svg } from "@natera/material/lib/svg";
import BillingContactUs from "@app/postBill/components/billingContactUs";
import { HEAP_EVENTS } from "@app/provider/types";
import { useUPSHeapEvent } from "@app/ups/hooks";
import "./upsNoLongerAvailable.scss";

const messages = defineMessages({
  upsNoLongerAvailablePageTitle: {
    id: "upsNoLongerAvailablePageTitle",
    defaultMessage: "Billing link no longer available",
  },
});

const UPSNoLongerAvailable: FC = () => {
  const intl = useIntl();
  const { trackUPSHeapEvent } = useUPSHeapEvent();

  useEffect(() => {
    trackUPSHeapEvent({
      eventKey: HEAP_EVENTS.ups_linkexpired,
    });
  }, []);

  return (
    <div className="ups-no-longer-available-page">
      <div className="ups-no-longer-available-page__container">
        <Svg
          className="ups-no-longer-available-page__container__icon"
          content={SearchCloudCircleIcon}
        />
        <div className="ups-no-longer-available-page__container__title">
          {intl.formatMessage(messages.upsNoLongerAvailablePageTitle)}
        </div>
        <BillingContactUs />
      </div>
    </div>
  );
};

export default UPSNoLongerAvailable;
